export default "__VITE_ASSET__BYFJBgxJ__"